(function () {
  'use strict';

  const ROOT_SELECTOR = '[data-fragrance-library][data-finder-url]';
  const PARAMS = {
    query: 'finder_q',
    brand: 'finder_brand',
    accord: 'finder_accord',
    note: 'finder_note',
    group: 'finder_group',
    sort: 'finder_sort'
  };
  const HISTORY_VISIBLE_KEY = 'pellairFinderVisible';
  const GROUPS = [
    { name: 'Fresh', root: 'fresh' },
    { name: 'Sweet', root: 'sweet' },
    { name: 'Woody', root: 'woody' },
    { name: 'Oud', root: 'oud' },
    { name: 'Floral', root: 'floral' },
    { name: 'Clean', root: 'clean' },
    { name: 'Spicy', root: 'spicy' }
  ];
  const GUIDED_NOTE_FAMILIES = [
    { name: 'Citrus light', description: 'Bright, sparkling and lifted', notes: ['Bergamot', 'Lemon', 'Grapefruit', 'Blood Orange'] },
    { name: 'Petals', description: 'Floral, soft and expressive', notes: ['Jasmine', 'Iris', 'Gardenia', 'Freesia'] },
    { name: 'Fruit', description: 'Juicy, crisp and colourful', notes: ['Apple', 'Apricot', 'Black Currant', 'Fig'] },
    { name: 'Green', description: 'Leafy, herbal and aromatic', notes: ['Basil', 'Green Tea', 'Grass', 'Lavender'] },
    { name: 'Spice', description: 'Dry, warm and energetic', notes: ['Cardamom', 'Cinnamon', 'Black Pepper', 'Ginger'] },
    { name: 'Depth', description: 'Woods, resins and texture', notes: ['Cedar', 'Guaiac Wood', 'Labdanum', 'Leather'] }
  ];
  const DEFAULT_NOTE_LIMIT = 12;
  const MOBILE_NOTE_LIMIT = 6;
  const NOTE_BATCH_SIZE = 12;
  const GUIDED_NOTE_LIMIT = 18;
  const LOADING_CARD_COUNT = 8;
  const POPULAR_PRODUCT_HANDLES = [
    'p-0247-creed-aventus',
    'p-0772-mfk-baccarat-rouge-540',
    'p-1058-tom-ford-lost-cherry',
    'p-1150-xerjoff-naxos',
    'p-1168-ysl-black-opium',
    'p-0551-initio-musk-therapy',
    'p-0552-initio-oud-for-greatness',
    'p-0550-initio-high-frequency',
    'p-0884-paco-rabanne-one-million-royal',
    'p-0554-initio-paragon',
    'p-0553-initio-oud-for-happiness',
    'p-0311-dior-sauvage-edp',
    'p-0206-chanel-bleu-de-chanel-edp',
    'p-0717-louis-vuitton-ombre-nomade',
    'p-0708-louis-vuitton-imagination',
    'p-0904-parfums-de-marly-layton',
    'p-1140-xerjoff-erba-pura',
    'p-0747-marc-antoine-barrois-ganymede',
    'p-0696-louis-vuitton-afternoon-swim',
    'p-1074-tom-ford-oud-wood',
    'p-0727-maison-crivelli-hibiscus-mahajad',
    'p-0896-parfums-de-marly-delina',
    'p-0146-bvlgari-tygar',
    'p-0246-creed-aventus-cologne',
    'p-0253-creed-green-irish-tweed',
    'p-0681-le-labo-santal-33',
    'p-0672-le-labo-another-13',
    'p-1130-xerjoff-40-knots',
    'p-0776-mfk-grand-soir',
    'p-0774-mfk-gentle-fluidity-gold',
    'p-0033-amouage-guidance-lastest',
    'p-0038-amouage-interlude-man',
    'p-0056-amouage-reflection-man',
    'p-0405-giorgio-armani-acqua-di-gio-profumo',
    'p-0217-chanel-coco-mademoiselle',
    'p-1029-tiziana-terenzi-kirke'
  ];
  const POPULARITY_RANK = new Map(POPULAR_PRODUCT_HANDLES.map(function (handle, index) {
    return [handle, index];
  }));
  const POPULAR_HOUSES = [
    'MFK', 'Tom Ford', 'Creed', 'Louis Vuitton', 'Initio', 'Xerjoff',
    'Parfums de Marly', 'Chanel', 'Dior', 'YSL', 'Giorgio Armani', 'Bvlgari'
  ];
  const NICHE_HOUSES = [
    'Amouage', 'Maison Crivelli', 'Marc Antoine Barrois', 'Nishane',
    'Le Labo', 'Tiziana Terenzi', 'Frederic Malle', 'Memo Paris',
    'Roja Dove', 'BDK Parfums', 'By Kilian', 'Kilian', 'Kilian Kologne', 'Ex Nihilo'
  ];
  const POPULAR_HOUSE_RANK = new Map(POPULAR_HOUSES.map(function (house, index) {
    return [normalize(house), index];
  }));
  const NICHE_HOUSE_RANK = new Map(NICHE_HOUSES.map(function (house, index) {
    return [normalize(house), index];
  }));
  const cache = new Map();
  const controllers = new Map();
  const globalScope = createScope();
  const previous = window.PellairFinderRuntime;
  const themeConfig = window.PellairTheme && typeof window.PellairTheme === 'object'
    ? window.PellairTheme
    : {};
  const themeRoutes = themeConfig.routes || {};
  const noteLibrary = window.PellairNoteLibrary && typeof window.PellairNoteLibrary.resolve === 'function' ? window.PellairNoteLibrary : null;

  if (previous && typeof previous.destroyAll === 'function') {
    try { previous.destroyAll(); } catch (error) {}
  }

  function createScope() {
    const cleanups = [];
    let destroyed = false;

    function add(cleanup) {
      if (typeof cleanup !== 'function') return;
      if (destroyed) {
        try { cleanup(); } catch (error) {}
      } else {
        cleanups.push(cleanup);
      }
    }

    function listen(target, type, handler, options) {
      if (!target || !target.addEventListener) return;
      target.addEventListener(type, handler, options);
      add(function () { target.removeEventListener(type, handler, options); });
    }

    function timeout(callback, delay) {
      const id = window.setTimeout(callback, delay);
      add(function () { window.clearTimeout(id); });
      return id;
    }

    function destroy() {
      if (destroyed) return;
      destroyed = true;
      cleanups.splice(0).reverse().forEach(function (cleanup) {
        try { cleanup(); } catch (error) {}
      });
    }

    return { add: add, listen: listen, timeout: timeout, destroy: destroy };
  }

  function queryRoots(root) {
    const results = [];
    if (!root) return results;
    if (root.nodeType === 1 && root.matches(ROOT_SELECTOR)) results.push(root);
    if (root.querySelectorAll) results.push.apply(results, root.querySelectorAll(ROOT_SELECTOR));
    return results;
  }

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  function customerText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function cleanTerms(values) {
    const seen = new Set();
    const output = [];
    (Array.isArray(values) ? values : []).forEach(function (value) {
      const text = customerText(value);
      const key = normalize(text);
      if (!text || !key || seen.has(key)) return;
      seen.add(key);
      output.push(text);
    });
    return output;
  }

  function cleanProfileNotes(noteValues, accordValues) {
    const accords = cleanTerms(accordValues);
    const accordKeys = new Set(accords.map(normalize));
    const notes = cleanTerms(noteValues).filter(function (note) {
      const key = normalize(note);
      return !/\baccords?\b/i.test(note) && ![
        'no exact perfume page found',
        'page has no note pyramid',
        'official mfk amyris material described',
        'original fahrenheit page',
        'appears to keep good girl profile'
      ].some(function (marker) {
        return key.indexOf(marker) !== -1;
      });
    });
    const overlapCount = notes.filter(function (note) { return accordKeys.has(normalize(note)); }).length;
    if (notes.length >= 5 && overlapCount / notes.length >= 0.75) return [];
    return notes;
  }

  function safeHref(value, fallback) {
    const candidate = String(value || '').trim();
    if (!candidate) return fallback || '#';
    try {
      const url = new URL(candidate, window.location.href);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return fallback || '#';
      return url.origin === window.location.origin
        ? url.pathname + url.search + url.hash
        : url.href;
    } catch (error) {
      return fallback || '#';
    }
  }

  function safeImage(value) {
    const candidate = String(value || '').trim();
    if (!candidate) return '';
    try {
      const url = new URL(candidate, window.location.href);
      return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : '';
    } catch (error) {
      return '';
    }
  }

  function productHref(product) {
    const allProducts = themeRoutes.allProducts || '/collections/all';
    const handle = product.shopifyHandle || product.handle || product.titleHandle || '';
    const root = String(themeRoutes.root || '/').replace(/\/?$/, '/');
    if (handle) return root + 'products/' + encodeURIComponent(handle);
    return safeHref(product.productUrl || product.url, allProducts);
  }

  function productTitle(product) {
    const shopifyTitle = customerText(product.shopifyTitle);
    if (shopifyTitle) return shopifyTitle;
    const fragrance = customerText(product.fragrance || product.title);
    const house = customerText(product.house);
    if (house && fragrance && normalize(fragrance).indexOf(normalize(house)) !== 0) return house + ' — ' + fragrance;
    return fragrance || house || 'Pellair oil';
  }

  function scentGroups(accords) {
    const normalized = cleanTerms(accords).map(normalize);
    return GROUPS.filter(function (group) {
      return normalized.some(function (accord) {
        return accord === group.root || accord.indexOf(group.root) !== -1;
      });
    }).map(function (group) { return group.name; });
  }

  function stableDiscoveryRank(value, index) {
    const text = normalize(value) || String(index || 0);
    let hash = 2166136261;
    for (let position = 0; position < text.length; position += 1) {
      hash ^= text.charCodeAt(position);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  }

  function prepareProduct(product, index) {
    const accords = cleanTerms(product.accords);
    const notes = cleanProfileNotes(product.notes, accords);
    const title = productTitle(product);
    const house = customerText(product.house);
    const groups = scentGroups(accords);
    const handle = customerText(product.handle || product.shopifyHandle);
    return {
      source: product,
      index: index,
      handle: handle,
      popularityRank: POPULARITY_RANK.has(handle)
        ? POPULARITY_RANK.get(handle)
        : POPULAR_PRODUCT_HANDLES.length + stableDiscoveryRank(handle, index),
      title: title,
      house: house,
      href: productHref(product),
      image: safeImage(product.image || product.imageSrc || product.featuredImage),
      imageAlt: customerText(product.imageAlt) || title,
      notes: notes,
      accords: accords,
      groups: groups,
      normalizedBrand: normalize(house),
      normalizedNotes: notes.map(normalize),
      normalizedAccords: accords.map(normalize),
      normalizedGroups: groups.map(normalize),
      searchText: normalize([
        title,
        house,
        notes.join(' '),
        accords.join(' '),
        groups.join(' ')
      ].join(' '))
    };
  }

  function countValues(products, getter) {
    const values = new Map();
    products.forEach(function (product) {
      (getter(product) || []).forEach(function (value) {
        const text = customerText(value);
        const key = normalize(text);
        if (!text || !key) return;
        if (!values.has(key)) values.set(key, { name: text, count: 0 });
        values.get(key).count += 1;
      });
    });
    return Array.from(values.values());
  }

  async function fetchLibrary(url, signal) {
    if (cache.has(url)) return cache.get(url);
    const response = await window.fetch(url, {
      credentials: 'same-origin',
      cache: 'force-cache',
      headers: { Accept: 'application/json' },
      signal: signal
    });
    if (!response.ok) throw new Error('The scent finder could not load.');
    const text = await response.text();
    let payload;
    try { payload = JSON.parse(text); } catch (error) { throw new Error('The scent finder data is unreadable.'); }
    if (!payload || !Array.isArray(payload.products)) throw new Error('The scent finder data is incomplete.');
    const prepared = {
      products: payload.products.filter(function (product) {
        return product && (product.shopifyTitle || product.fragrance || product.title);
      }).map(prepareProduct),
      summary: payload.summary || {}
    };
    cache.set(url, prepared);
    return prepared;
  }

  function readURLState() {
    const params = new URL(window.location.href).searchParams;
    return {
      query: customerText(params.get(PARAMS.query) || ''),
      brand: cleanTerms(params.getAll(PARAMS.brand)),
      accord: cleanTerms(params.getAll(PARAMS.accord)),
      note: cleanTerms(params.getAll(PARAMS.note)),
      group: cleanTerms(params.getAll(PARAMS.group)),
      sort: params.get(PARAMS.sort) || 'featured'
    };
  }

  function nativeCatalogRequest() {
    const params = new URL(window.location.href).searchParams;
    const nativeSort = params.get('sort_by');
    if (nativeSort && nativeSort !== 'manual') return true;
    return Array.from(params.keys()).some(function (key) { return key.indexOf('filter.') === 0; });
  }

  function restoredVisible(defaultVisible) {
    const value = Number(window.history && window.history.state && window.history.state[HISTORY_VISIBLE_KEY]);
    if (!Number.isFinite(value) || value < defaultVisible) return defaultVisible;
    return Math.floor(value);
  }

  function writeURLState(state, mode) {
    if (!window.history || !window.history.pushState) return;
    const url = new URL(window.location.href);
    Object.keys(PARAMS).forEach(function (key) { url.searchParams.delete(PARAMS[key]); });
    url.searchParams.delete('sort_by');
    if (state.query) url.searchParams.set(PARAMS.query, state.query);
    ['brand', 'accord', 'note', 'group'].forEach(function (key) {
      state[key].forEach(function (value) { url.searchParams.append(PARAMS[key], value); });
    });
    if (state.sort && state.sort !== 'featured') url.searchParams.set(PARAMS.sort, state.sort);
    const method = mode === 'push' ? 'pushState' : 'replaceState';
    const historyState = Object.assign({}, window.history.state || {});
    historyState[HISTORY_VISIBLE_KEY] = state.visible;
    window.history[method](historyState, '', url.pathname + url.search + url.hash);
  }

  function createFinderController(root) {
    const scope = createScope();
    const dataUrl = root.getAttribute('data-finder-url') || '';
    const search = root.querySelector('[data-fragrance-search]');
    const searchControl = root.querySelector('[data-finder-search-control]');
    const predictions = root.querySelector('[data-finder-predictions]');
    const brand = root.querySelector('[data-fragrance-brand]');
    const accord = root.querySelector('[data-fragrance-accord]');
    const note = root.querySelector('[data-fragrance-note]');
    const group = root.querySelector('[data-fragrance-mood], [data-fragrance-group]');
    const sort = root.querySelector('[data-fragrance-sort]');
    const result = root.querySelector('[data-fragrance-results]');
    const count = root.querySelector('[data-fragrance-count]');
    const status = root.querySelector('[data-fragrance-status]');
    const retry = root.querySelector('[data-fragrance-retry]');
    const clear = root.querySelector('[data-fragrance-clear]');
    const loadMore = root.querySelector('[data-fragrance-load-more]');
    const stats = root.querySelector('[data-fragrance-stats]');
    const noteCloud = root.querySelector('[data-note-cloud]');
    const guidedNoteFamilies = root.querySelector('[data-guided-note-families]');
    const groupCloud = root.querySelector('[data-mood-cloud], [data-group-cloud]');
    const showFewerNotes = root.querySelector('[data-show-fewer-notes]');
    const controls = root.querySelector('.fragrance-controls');
    const moreFilters = root.querySelector('[data-more-filters]');
    const moreFilterSummary = root.querySelector('[data-more-filter-summary]');
    const catalogFallback = document.querySelector('.collection-main--catalog-fallback');
    if (catalogFallback && nativeCatalogRequest()) {
      const fallbackHeading = catalogFallback.querySelector('[data-collection-heading]');
      root.hidden = true;
      document.body.classList.remove('finder-catalog-loading', 'finder-catalog-ready');
      document.body.classList.add('finder-catalog-native');
      if (fallbackHeading) {
        fallbackHeading.setAttribute('role', 'heading');
        fallbackHeading.setAttribute('aria-level', '1');
      }
      return {
        applyURL: function () { if (!nativeCatalogRequest()) window.location.reload(); },
        pageHide: function () {},
        pageShow: function () { if (!nativeCatalogRequest()) window.location.reload(); },
        editorSelect: function () {},
        destroy: function () {
          root.hidden = false;
          document.body.classList.remove('finder-catalog-native');
          if (fallbackHeading) {
            fallbackHeading.removeAttribute('role');
            fallbackHeading.removeAttribute('aria-level');
          }
          scope.destroy();
        }
      };
    }
    const defaultVisible = Math.max(8, Number(root.getAttribute('data-max-cards') || 24));
    const desktopNoteLimit = Math.max(4, Number(root.getAttribute('data-note-limit') || DEFAULT_NOTE_LIMIT));
    const mobileNoteLimit = Math.max(3, Number(root.getAttribute('data-note-limit-mobile') || MOBILE_NOTE_LIMIT));
    const initialNoteLimit = window.matchMedia && window.matchMedia('(max-width: 749px)').matches
      ? mobileNoteLimit
      : desktopNoteLimit;
    const state = Object.assign(readURLState(), { visible: restoredVisible(defaultVisible), noteVisible: initialNoteLimit });
    let hasRenderedProductCards = false;
    if (!group) state.group = [];
    let products = [];
    let brands = [];
    let accords = [];
    let notes = [];
    let groups = [];
    let additionalNoteCount = 0;
    let loaded = false;
    let loading = false;
    let fetchController = null;
    const livePriceCache = window.PellairLiveProductPriceCache instanceof Map
      ? window.PellairLiveProductPriceCache
      : new Map();
    window.PellairLiveProductPriceCache = livePriceCache;
    const livePriceQueue = [];
    let activeLivePriceRequests = 0;
    let inputTimer = 0;
    let searchHasHistoryEntry = Boolean(state.query);
    let activeChips = root.querySelector('[data-fragrance-active-chips]');
    const enhancedSelects = new Map();

    if (result) {
      result.setAttribute('aria-live', 'off');
      result.setAttribute('aria-busy', 'false');
    }
    if (retry) retry.hidden = true;
    if (clear) {
      clear.disabled = true;
      clear.setAttribute('aria-disabled', 'true');
    }

    if (!activeChips && controls) {
      activeChips = document.createElement('div');
      activeChips.className = 'fragrance-active-chips';
      activeChips.setAttribute('data-fragrance-active-chips', '');
      activeChips.hidden = true;
      controls.insertAdjacentElement('afterend', activeChips);
    }

    function announce(message, error) {
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
      status.classList.toggle('is-error', !!error);
      status.dataset.state = error ? 'error' : (message ? 'status' : 'idle');
    }

    function optionItems(select, items, placeholder) {
      if (!select) return;
      const fragment = document.createDocumentFragment();
      const first = document.createElement('option');
      first.value = '';
      first.textContent = placeholder;
      first.disabled = true;
      fragment.appendChild(first);
      items.forEach(function (item) {
        const option = document.createElement('option');
        option.value = item.name;
        option.textContent = item.name + ' (' + item.count + ')';
        fragment.appendChild(option);
      });
      select.replaceChildren(fragment);
    }

    function closeEnhancedSelects(except) {
      enhancedSelects.forEach(function (controller) {
        if (controller !== except) controller.close(false);
      });
    }

    function enhanceSelect(select, items, configuration) {
      if (!select) return null;
      const existing = enhancedSelects.get(select);
      if (existing) {
        existing.setItems(items);
        return existing;
      }

      const control = select.closest('.fragrance-control');
      if (!control) return null;
      const component = document.createElement('div');
      const button = document.createElement('button');
      const current = document.createElement('span');
      const caret = document.createElement('span');
      const scrim = document.createElement('button');
      const popover = document.createElement('div');
      const heading = document.createElement('div');
      const title = document.createElement('strong');
      const close = document.createElement('button');
      const searchField = document.createElement('label');
      const searchInput = document.createElement('input');
      const optionsList = document.createElement('div');
      const empty = document.createElement('p');
      const footer = document.createElement('div');
      const clearSelection = document.createElement('button');
      const applySelection = document.createElement('button');
      const popoverId = (select.id || 'PellairSelect-' + Math.random().toString(36).slice(2)) + '-Popover';
      const titleId = popoverId + '-Title';
      const optionsId = popoverId + '-Options';
      let availableItems = Array.isArray(items) ? items : [];
      let selectedValues = [];
      let open = false;
      let renderLimit = configuration.key === 'note' ? 72 : Number.MAX_SAFE_INTEGER;

      component.className = 'pellair-select';
      component.setAttribute('data-pellair-select', configuration.key);
      button.className = 'pellair-select__button';
      button.type = 'button';
      button.setAttribute('role', 'combobox');
      button.setAttribute('aria-haspopup', 'listbox');
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', optionsId);
      button.setAttribute('aria-label', configuration.label);
      button.setAttribute('aria-autocomplete', 'none');
      current.className = 'pellair-select__current';
      caret.className = 'pellair-select__caret';
      caret.setAttribute('aria-hidden', 'true');
      caret.textContent = '⌄';
      button.append(current, caret);

      scrim.className = 'pellair-select__scrim';
      scrim.type = 'button';
      scrim.tabIndex = -1;
      scrim.setAttribute('aria-label', 'Close ' + configuration.label.toLowerCase());
      scrim.hidden = true;

      popover.className = 'pellair-select__popover';
      popover.id = popoverId;
      popover.hidden = true;
      popover.setAttribute('role', 'dialog');
      popover.setAttribute('aria-labelledby', titleId);
      heading.className = 'pellair-select__heading';
      title.id = titleId;
      title.textContent = configuration.label;
      close.className = 'plain pellair-select__close';
      close.type = 'button';
      close.setAttribute('aria-label', 'Close ' + configuration.label.toLowerCase());
      close.textContent = '×';
      heading.append(title, close);

      searchField.className = 'pellair-select__search';
      searchField.innerHTML = '<span class="visually-hidden">' + escapeHTML(configuration.searchPlaceholder || ('Search ' + configuration.label.toLowerCase())) + '</span>';
      searchInput.type = 'search';
      searchInput.autocomplete = 'off';
      searchInput.placeholder = configuration.searchPlaceholder || ('Search ' + configuration.label.toLowerCase());
      searchInput.setAttribute('aria-controls', optionsId);
      searchField.appendChild(searchInput);
      if (!configuration.searchable) searchField.hidden = true;

      optionsList.className = 'pellair-select__options';
      optionsList.id = optionsId;
      optionsList.setAttribute('role', 'listbox');
      optionsList.setAttribute('aria-multiselectable', String(select.multiple || select.hasAttribute('data-fragrance-multi')));
      empty.className = 'pellair-select__empty';
      empty.textContent = 'No matching options.';
      empty.setAttribute('role', 'status');
      empty.setAttribute('aria-live', 'polite');
      empty.hidden = true;
      footer.className = 'pellair-select__footer';
      clearSelection.className = 'button button--ghost button--small';
      clearSelection.type = 'button';
      clearSelection.textContent = 'Clear';
      applySelection.className = 'button button--small';
      applySelection.type = 'button';
      applySelection.textContent = 'Done';
      footer.append(clearSelection, applySelection);
      popover.append(heading, searchField, optionsList, empty, footer);
      component.append(button, scrim, popover);
      select.insertAdjacentElement('afterend', component);
      select.hidden = true;
      select.setAttribute('aria-hidden', 'true');
      select.tabIndex = -1;

      function visibleOptions() {
        return Array.from(optionsList.querySelectorAll('[role="option"]')).filter(function (option) { return !option.hidden; });
      }

      function focusableElements() {
        return Array.from(popover.querySelectorAll('button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
          return !element.hidden && element.tabIndex >= 0 && element.getAttribute('aria-hidden') !== 'true';
        });
      }

      function focusOption(option) {
        if (!option) return;
        optionsList.querySelectorAll('[role="option"]').forEach(function (entry) { entry.tabIndex = -1; });
        option.tabIndex = 0;
        option.focus({ preventScroll: true });
      }

      function isSelected(value) {
        const wanted = normalize(value);
        return selectedValues.some(function (entry) { return normalize(entry) === wanted; });
      }

      function selectionLabel() {
        if (!selectedValues.length) return configuration.placeholder;
        if (selectedValues.length === 1) return selectedValues[0];
        return selectedValues.length + ' ' + configuration.plural + ' selected';
      }

      function update(values) {
        selectedValues = Array.isArray(values) ? values.slice() : [];
        current.textContent = selectionLabel();
        button.classList.toggle('has-selection', selectedValues.length > 0);
        optionsList.querySelectorAll('[role="option"]').forEach(function (option) {
          const selected = isSelected(option.getAttribute('data-value'));
          option.classList.toggle('is-selected', selected);
          option.setAttribute('aria-selected', String(selected));
        });
        clearSelection.disabled = selectedValues.length === 0;
      }

      function buildItems() {
        const fragment = document.createDocumentFragment();
        const query = normalize(searchInput.value);
        const matchingItems = availableItems.filter(function (item) {
          return !query || normalize(item.name).indexOf(query) !== -1;
        });
        if (!query && selectedValues.length) {
          matchingItems.sort(function (left, right) {
            return Number(isSelected(right.name)) - Number(isSelected(left.name));
          });
        }
        const renderedItems = matchingItems.slice(0, renderLimit);
        renderedItems.forEach(function (item) {
          const option = document.createElement('button');
          const label = document.createElement('span');
          const count = document.createElement('small');
          const check = document.createElement('span');
          option.type = 'button';
          option.className = 'pellair-select__option';
          option.setAttribute('role', 'option');
          option.setAttribute('data-value', item.name);
          option.setAttribute('data-search-text', normalize(item.name));
          option.setAttribute('aria-selected', 'false');
          option.tabIndex = -1;
          label.className = 'pellair-select__option-label';
          label.textContent = item.name;
          if (item.category) {
            const badge = document.createElement('em');
            badge.className = 'pellair-select__option-badge';
            badge.textContent = item.category;
            label.appendChild(badge);
          }
          count.textContent = String(item.count || 0);
          check.className = 'pellair-select__check';
          check.setAttribute('aria-hidden', 'true');
          check.textContent = '✓';
          option.appendChild(check);
          if (configuration.key === 'note' && noteLibrary) {
            const visual = noteLibrary.resolve(item.name);
            if (visual && !visual.inferred) {
              const media = document.createElement('span');
              const image = document.createElement('img');
              media.className = 'pellair-select__option-visual';
              image.src = noteLibrary.url(visual, 192);
              image.alt = '';
              image.width = 96;
              image.height = 54;
              image.loading = 'lazy';
              image.decoding = 'async';
              media.appendChild(image);
              option.classList.add('has-visual');
              option.appendChild(media);
            }
          }
          option.append(label, count);
          fragment.appendChild(option);
        });
        optionsList.replaceChildren(fragment);
        update(selectedValues);
        empty.hidden = renderedItems.length !== 0;
      }

      function setItems(nextItems) {
        availableItems = Array.isArray(nextItems) ? nextItems : [];
        buildItems();
      }

      function filterItems() {
        const query = normalize(searchInput.value);
        renderLimit = configuration.key === 'note'
          ? (query ? 120 : 72)
          : Number.MAX_SAFE_INTEGER;
        buildItems();
      }

      function setOpen(next, restoreFocus) {
        if (open === next) return;
        open = next;
        component.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
        popover.hidden = !open;
        scrim.hidden = !open;
        const anyOpen = open || Array.from(enhancedSelects.values()).some(function (entry) { return entry !== controller && entry.isOpen(); });
        document.documentElement.classList.toggle('finder-select-open', anyOpen);
        document.body.classList.toggle('finder-select-open', anyOpen);
        if (open) {
          closeEnhancedSelects(controller);
          window.requestAnimationFrame(function () {
            if (configuration.searchable) searchInput.focus({ preventScroll: true });
            else {
              const first = visibleOptions()[0];
              if (first) focusOption(first);
            }
          });
        } else {
          searchInput.value = '';
          filterItems();
          if (restoreFocus) button.focus({ preventScroll: true });
        }
      }

      function onOptionsKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          setOpen(false, true);
          return;
        }
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp' && event.key !== 'Home' && event.key !== 'End') return;
        const options = visibleOptions();
        if (!options.length) return;
        event.preventDefault();
        const currentIndex = options.indexOf(document.activeElement);
        let nextIndex = currentIndex;
        if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = options.length - 1;
        else if (event.key === 'ArrowDown') nextIndex = Math.min(options.length - 1, currentIndex + 1);
        else nextIndex = Math.max(0, currentIndex < 0 ? options.length - 1 : currentIndex - 1);
        focusOption(options[nextIndex]);
      }

      const controller = {
        close: function (restoreFocus) { setOpen(false, restoreFocus); },
        isOpen: function () { return open; },
        setItems: setItems,
        update: update
      };
      enhancedSelects.set(select, controller);

      scope.listen(button, 'click', function () { setOpen(!open, false); });
      scope.listen(button, 'keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setOpen(true, false);
        }
      });
      scope.listen(searchInput, 'input', filterItems);
      scope.listen(searchInput, 'keydown', function (event) {
        if (event.key === 'ArrowDown') {
          const first = visibleOptions()[0];
          if (first) {
            event.preventDefault();
            focusOption(first);
          }
        } else if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          setOpen(false, true);
        }
      });
      scope.listen(popover, 'keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(false, true);
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = focusableElements();
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus({ preventScroll: true });
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus({ preventScroll: true });
        }
      });
      scope.listen(optionsList, 'keydown', onOptionsKeydown);
      scope.listen(optionsList, 'click', function (event) {
        const option = event.target.closest('[role="option"]');
        if (!option) return;
        event.preventDefault();
        toggle(configuration.key, option.getAttribute('data-value'));
        focusOption(option);
      });
      scope.listen(close, 'click', function () { setOpen(false, true); });
      scope.listen(scrim, 'click', function () { setOpen(false, true); });
      scope.listen(applySelection, 'click', function () { setOpen(false, true); });
      scope.listen(clearSelection, 'click', function () {
        state[configuration.key] = [];
        commit('push');
      });
      scope.listen(document, 'pointerdown', function (event) {
        if (open && !component.contains(event.target)) setOpen(false, false);
      });
      scope.add(function () {
        setOpen(false, false);
        enhancedSelects.delete(select);
        component.remove();
        select.hidden = false;
        select.removeAttribute('aria-hidden');
        select.removeAttribute('tabindex');
      });

      buildItems();
      return controller;
    }

    function sanitizeSort() {
      if (!sort) return;
      Array.from(sort.options).forEach(function (option) {
        if (/^price-/i.test(option.value)) option.remove();
        if (option.value === 'featured') option.textContent = 'Relevant';
        if (option.value === 'title-ascending') option.textContent = 'Name A–Z';
        if (option.value === 'title-descending') option.textContent = 'Name Z–A';
      });
      if (!Array.from(sort.options).some(function (option) { return option.value === 'title-ascending'; })) {
        sort.add(new Option('Name A–Z', 'title-ascending'));
      }
      if (!Array.from(sort.options).some(function (option) { return option.value === 'title-descending'; })) {
        sort.add(new Option('Name Z–A', 'title-descending'));
      }
      if (!Array.from(sort.options).some(function (option) { return option.value === state.sort; })) state.sort = 'featured';
    }

    function canonicalValues(values, items) {
      const catalogue = new Map();
      items.forEach(function (item) { catalogue.set(normalize(item.name), item.name); });
      const seen = new Set();
      return values.reduce(function (output, value) {
        const key = normalize(value);
        const canonical = catalogue.get(key);
        if (!canonical || seen.has(key)) return output;
        seen.add(key);
        output.push(canonical);
        return output;
      }, []);
    }

    function canonicalizeState() {
      const before = JSON.stringify([state.brand, state.accord, state.note, state.group, state.sort]);
      state.brand = canonicalValues(state.brand, brands);
      state.accord = canonicalValues(state.accord, accords);
      state.note = canonicalValues(state.note, notes);
      state.group = canonicalValues(state.group, groups);
      const allowedSorts = ['featured', 'title-ascending', 'title-descending'];
      if (allowedSorts.indexOf(state.sort) === -1) state.sort = 'featured';
      return before !== JSON.stringify([state.brand, state.accord, state.note, state.group, state.sort]);
    }

    function selectedFrom(select) {
      if (!select) return [];
      if (select.multiple) {
        return Array.from(select.selectedOptions).map(function (option) { return option.value; }).filter(Boolean);
      }
      return select.value ? [select.value] : [];
    }

    function syncSelect(select, values) {
      if (!select) return;
      if (select.hasAttribute('data-fragrance-multi')) {
        select.dataset.selectedValues = JSON.stringify(values);
        const normalized = values.map(normalize);
        Array.from(select.options).forEach(function (option) {
          option.selected = !!option.value && normalized.indexOf(normalize(option.value)) !== -1;
        });
        if (!select.multiple) select.value = values.length ? values[values.length - 1] : '';
        return;
      }
      const normalized = values.map(normalize);
      Array.from(select.options).forEach(function (option) {
        option.selected = !!option.value && normalized.indexOf(normalize(option.value)) !== -1;
      });
      if (!select.multiple) select.value = values[0] || '';
    }

    function syncControls() {
      if (search) search.value = state.query;
      syncSelect(brand, state.brand);
      syncSelect(accord, state.accord);
      syncSelect(note, state.note);
      syncSelect(group, state.group);
      if (sort) sort.value = state.sort;
      [[brand, state.brand], [accord, state.accord], [note, state.note], [group, state.group]].forEach(function (entry) {
        const controller = enhancedSelects.get(entry[0]);
        if (controller) controller.update(entry[1]);
      });
      if (moreFilters && (state.accord.length || state.group.length || state.sort !== 'featured')) moreFilters.open = true;
    }

    function active(values, value) {
      const wanted = normalize(value);
      return values.some(function (entry) { return normalize(entry) === wanted; });
    }

    function cloudHTML(items, type, limit) {
      return items.slice(0, limit).map(function (item) {
        const visual = type === 'note' && noteLibrary ? noteLibrary.resolve(item.name) : null;
        if (visual && !visual.inferred) {
          const image = noteLibrary.url(visual, 320);
          return '<button type="button" class="taxonomy-pill taxonomy-pill--note taxonomy-note-card" data-filter-note="' +
            escapeHTML(item.name) + '" aria-label="Filter by ' + escapeHTML(item.name) + ', ' + item.count + ' oils">' +
            '<span class="taxonomy-note-card__media"><img src="' + escapeHTML(image) + '" alt="" width="480" height="270" loading="lazy" decoding="async" data-note-image></span>' +
            '<span class="taxonomy-note-card__copy"><span>' + escapeHTML(item.name) + '</span><small class="visually-hidden">' + item.count + ' oils</small></span>' +
          '</button>';
        }
        if (type === 'note') {
          return '<button type="button" class="taxonomy-pill taxonomy-pill--note taxonomy-note-card is-image-missing" data-filter-note="' +
            escapeHTML(item.name) + '" aria-label="Filter by ' + escapeHTML(item.name) + ', ' + item.count + ' oils">' +
            '<span class="taxonomy-note-card__copy"><span>' + escapeHTML(item.name) + '</span><small class="visually-hidden">' + item.count + ' oils</small></span>' +
          '</button>';
        }
        return '<button type="button" class="taxonomy-pill taxonomy-pill--' + type + '" data-filter-' + type + '="' +
          escapeHTML(item.name) + '">' + escapeHTML(item.name) + '<small>' + item.count + '</small></button>';
      }).join('');
    }

    function guidedNotesHTML(items) {
      const lookup = new Map(items.map(function (item) { return [normalize(item.name), item]; }));
      const used = new Set();
      const curated = [];
      GUIDED_NOTE_FAMILIES.forEach(function (family) {
        family.notes.forEach(function (name) {
          const item = lookup.get(normalize(name));
          const visual = item && noteLibrary ? noteLibrary.resolve(item.name) : null;
          if (!item || used.has(normalize(item.name)) || !visual || visual.inferred) return;
          used.add(normalize(item.name));
          curated.push(item);
        });
      });
      curated.sort(function (left, right) {
        return right.count - left.count || left.name.localeCompare(right.name);
      });
      const visible = curated.slice(0, GUIDED_NOTE_LIMIT);
      const visibleKeys = new Set(visible.map(function (item) { return normalize(item.name); }));
      return { html: cloudHTML(visible, 'note', visible.length), used: visibleKeys };
    }

    function renderClouds() {
      if (guidedNoteFamilies) guidedNoteFamilies.replaceChildren();
      const additionalNotes = notes.slice().sort(function (left, right) {
        return right.count - left.count || left.name.localeCompare(right.name);
      });
      additionalNoteCount = additionalNotes.length;
      state.noteVisible = Math.min(additionalNoteCount, Math.max(initialNoteLimit, state.noteVisible));
      if (noteCloud) {
        const renderedCount = noteCloud.children.length;
        if (renderedCount >= initialNoteLimit && state.noteVisible > renderedCount) {
          noteCloud.insertAdjacentHTML(
            'beforeend',
            cloudHTML(additionalNotes.slice(renderedCount, state.noteVisible), 'note', state.noteVisible - renderedCount)
          );
        } else if (renderedCount !== state.noteVisible) {
          noteCloud.innerHTML = cloudHTML(additionalNotes, 'note', state.noteVisible);
        }
      }
      if (groupCloud) groupCloud.innerHTML = cloudHTML(groups, 'group', groups.length);
      let more = root.querySelector('[data-show-more-notes]');
      if (noteCloud && additionalNotes.length > initialNoteLimit && !more) {
        more = document.createElement('button');
        more.type = 'button';
        more.className = 'button button--ghost button--small taxonomy-show-more';
        more.setAttribute('data-show-more-notes', '');
        more.setAttribute('aria-controls', noteCloud.id || '');
        noteCloud.insertAdjacentElement('afterend', more);
      }
      if (more) {
        const expanded = state.noteVisible > initialNoteLimit;
        more.hidden = additionalNotes.length <= initialNoteLimit || state.noteVisible >= additionalNoteCount;
        more.textContent = 'More notes';
        more.setAttribute('aria-expanded', String(expanded));
      }
      if (showFewerNotes) {
        showFewerNotes.hidden = state.noteVisible <= initialNoteLimit;
      }
    }

    function loadingCardsHTML() {
      return Array.from({ length: LOADING_CARD_COUNT }, function () {
        return '<article class="fragrance-card fragrance-card--skeleton" aria-hidden="true">' +
          '<span class="fragrance-card__image fragrance-card__skeleton-image"></span>' +
          '<div class="fragrance-card__body"><span class="fragrance-card__skeleton-line fragrance-card__skeleton-line--small"></span>' +
          '<span class="fragrance-card__skeleton-line fragrance-card__skeleton-line--title"></span>' +
          '<span class="fragrance-card__skeleton-line"></span></div></article>';
      }).join('');
    }

    function renderLoadingState() {
      if (!result) return;
      result.hidden = false;
      result.innerHTML = loadingCardsHTML();
      result.setAttribute('aria-busy', 'true');
    }

    function renderErrorState() {
      if (catalogFallback) document.body.classList.remove('finder-catalog-loading', 'finder-catalog-ready');
      if (!result) return;
      result.innerHTML = '<div class="empty-state empty-state--finder"><p>The scent finder is temporarily unavailable.</p><p>Try again, or continue with the complete catalogue below.</p></div>';
      result.setAttribute('aria-busy', 'false');
    }

    function matchList(productValues, selected) {
      if (!selected.length) return true;
      return selected.every(function (value) {
        const wanted = normalize(value);
        return productValues.indexOf(wanted) !== -1;
      });
    }

    function matches(product) {
      if (state.brand.length && !state.brand.some(function (value) { return normalize(value) === product.normalizedBrand; })) return false;
      if (!matchList(product.normalizedAccords, state.accord)) return false;
      if (!matchList(product.normalizedNotes, state.note)) return false;
      if (!matchList(product.normalizedGroups, state.group)) return false;
      const terms = normalize(state.query).split(/\s+/).filter(Boolean);
      return terms.every(function (term) { return product.searchText.indexOf(term) !== -1; });
    }

    function matchReason(product) {
      if (state.note.length) return 'Includes ' + state.note.slice(0, 2).join(' + ');
      if (state.accord.length) return 'Matches ' + state.accord.slice(0, 2).join(' + ');
      if (state.group.length) return state.group.slice(0, 2).join(' + ') + ' profile';
      if (state.brand.length) return 'Brand match';
      if (state.query) return 'Matches your search';
      return '';
    }

    function cardTitle(product) {
      const title = customerText(product.title);
      const house = customerText(product.house);
      if (!house) return title;
      const pattern = new RegExp('^' + house.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*(?:—|-|:)\\s*', 'i');
      return title.replace(pattern, '') || title;
    }

    function closePredictions() {
      if (!predictions) return;
      predictions.hidden = true;
      predictions.replaceChildren();
      if (search) {
        search.setAttribute('aria-expanded', 'false');
        search.removeAttribute('aria-activedescendant');
      }
    }

    function setActivePrediction(item) {
      if (!predictions || !search) return;
      predictions.querySelectorAll('[data-finder-prediction]').forEach(function (option) {
        option.setAttribute('aria-selected', String(option === item));
      });
      if (item && item.id) search.setAttribute('aria-activedescendant', item.id);
      else search.removeAttribute('aria-activedescendant');
    }

    function predictionScore(product, query) {
      const title = normalize(product.title);
      const house = normalize(product.house);
      let score = 0;
      if (title === query) score += 1000;
      else if (title.indexOf(query) === 0) score += 700;
      else if (title.indexOf(query) !== -1) score += 420;
      if (house === query) score += 380;
      else if (house.indexOf(query) === 0) score += 220;
      if (product.normalizedNotes.some(function (value) { return value.indexOf(query) !== -1; })) score += 150;
      if (product.normalizedAccords.some(function (value) { return value.indexOf(query) !== -1; })) score += 100;
      return score;
    }

    function comparePopularity(left, right) {
      return left.popularityRank - right.popularityRank ||
        left.title.localeCompare(right.title) ||
        left.index - right.index;
    }

    function renderPredictions(value) {
      if (!predictions || !search || !loaded) return;
      const query = normalize(value);
      if (!query) {
        closePredictions();
        return;
      }
      const terms = query.split(/\s+/).filter(Boolean);
      const suggestions = products.filter(function (product) {
        return terms.every(function (term) { return product.searchText.indexOf(term) !== -1; });
      }).sort(function (left, right) {
        return predictionScore(right, query) - predictionScore(left, query) ||
          comparePopularity(left, right);
      }).slice(0, 6);
      if (!suggestions.length) {
        closePredictions();
        return;
      }
      predictions.innerHTML = suggestions.map(function (product, index) {
        const media = product.image
          ? '<img src="' + escapeHTML(product.image) + '" alt="" width="80" height="100" loading="eager" decoding="async">'
          : '<span aria-hidden="true">P</span>';
        return '<a id="' + escapeHTML(predictions.id + '-Option-' + index) +
          '" class="finder-predictions__item" data-finder-prediction role="option" aria-selected="false" href="' +
          escapeHTML(product.href) + '">' +
          '<span class="finder-predictions__media">' + media + '</span>' +
          '<span class="finder-predictions__copy"><small>' + escapeHTML(product.house || 'Fragrance oil') +
          '</small><strong>' + escapeHTML(cardTitle(product)) + '</strong></span>' +
          '<span class="finder-predictions__arrow" aria-hidden="true">→</span>' +
          '</a>';
      }).join('');
      predictions.hidden = false;
      search.removeAttribute('aria-activedescendant');
      search.setAttribute('aria-expanded', 'true');
    }

    function formatLivePriceWithDelimiters(cents, precision, thousands, decimal) {
      const amount = Number(cents || 0) / 100;
      const fixed = amount.toFixed(precision);
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[0] + (parts[1] ? decimal + parts[1] : '');
    }

    function formatLivePrice(cents) {
      const currency = String(themeConfig.currency || root.getAttribute('data-currency') || 'INR').trim().toUpperCase();
      const shopCurrency = String(themeConfig.shopCurrency || '').trim().toUpperCase();
      const moneyFormat = String(themeConfig.moneyFormat || '');
      const locale = themeConfig.locale || document.documentElement.lang || undefined;

      function finish(value) {
        const formatted = String(value || '');
        if (!themeConfig.showCurrencyCode || !currency || formatted.toUpperCase().indexOf(currency) !== -1) return formatted;
        return formatted + ' ' + currency;
      }

      if (moneyFormat.indexOf('{{') !== -1 && (!shopCurrency || currency === shopCurrency)) {
        return finish(moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
          if (token === 'amount_no_decimals') return formatLivePriceWithDelimiters(cents, 0, ',', '.');
          if (token === 'amount_with_comma_separator') return formatLivePriceWithDelimiters(cents, 2, '.', ',');
          if (token === 'amount_no_decimals_with_comma_separator') return formatLivePriceWithDelimiters(cents, 0, '.', ',');
          if (token === 'amount_with_apostrophe_separator') return formatLivePriceWithDelimiters(cents, 2, "'", '.');
          if (token === 'amount_no_decimals_with_space_separator') return formatLivePriceWithDelimiters(cents, 0, ' ', '.');
          if (token === 'amount_with_space_separator') return formatLivePriceWithDelimiters(cents, 2, ' ', ',');
          return formatLivePriceWithDelimiters(cents, 2, ',', '.');
        }));
      }

      try {
        return finish(new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
          currencyDisplay: themeConfig.showCurrencyCode ? 'code' : 'symbol'
        }).format(Number(cents || 0) / 100));
      } catch (error) {
        return finish(formatLivePriceWithDelimiters(cents, 2, ',', '.'));
      }
    }

    function runLivePriceQueue() {
      while (activeLivePriceRequests < 4 && livePriceQueue.length) {
        const task = livePriceQueue.shift();
        activeLivePriceRequests += 1;
        task().finally(function () {
          activeLivePriceRequests -= 1;
          runLivePriceQueue();
        });
      }
    }

    function liveProductPrice(handle) {
      const cleanHandle = customerText(handle);
      if (!cleanHandle) return Promise.reject(new Error('Missing product handle'));
      if (livePriceCache.has(cleanHandle)) return livePriceCache.get(cleanHandle);

      const request = new Promise(function (resolve, reject) {
        livePriceQueue.push(function () {
          const rootPath = String(themeRoutes.root || '/').replace(/\/?$/, '/');
          const endpoint = rootPath + 'products/' + encodeURIComponent(cleanHandle) + '.js';
          return fetch(endpoint, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          }).then(function (response) {
            if (!response.ok) throw new Error('Product price unavailable');
            return response.json();
          }).then(resolve, reject);
        });
        runLivePriceQueue();
      });
      livePriceCache.set(cleanHandle, request);
      request.catch(function () {
        if (livePriceCache.get(cleanHandle) === request) livePriceCache.delete(cleanHandle);
      });
      return request;
    }

    function livePriceMarkup(product) {
      const minimum = Number(product && (product.price_min != null ? product.price_min : product.price));
      const maximum = Number(product && (product.price_max != null ? product.price_max : minimum));
      if (!Number.isFinite(minimum) || minimum < 0) return '';
      const varies = Boolean(product.price_varies || maximum > minimum);
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const saleVariant = variants.find(function (variant) {
        return Number(variant.price) === minimum && Number(variant.compare_at_price || 0) > Number(variant.price || 0);
      });
      const compare = saleVariant ? Number(saleVariant.compare_at_price || 0) : 0;
      const rangeLabel = varies && maximum > minimum
        ? 'Prices range from ' + formatLivePrice(minimum) + ' to ' + formatLivePrice(maximum) + '.'
        : 'Price ' + formatLivePrice(minimum) + '.';
      return '<span class="visually-hidden">' + escapeHTML(rangeLabel) + '</span>' +
        (varies ? '<span class="price__from" aria-hidden="true">From</span>' : '') +
        (compare > minimum ? '<s class="price__compare" aria-hidden="true">' + escapeHTML(formatLivePrice(compare)) + '</s>' : '') +
        '<strong class="price__current" aria-hidden="true">' + escapeHTML(formatLivePrice(minimum)) + '</strong>';
    }

    function hydrateLivePrices(container) {
      if (!container) return;
      container.querySelectorAll('[data-live-product-price]').forEach(function (slot) {
        const handle = slot.getAttribute('data-product-handle') || '';
        liveProductPrice(handle).then(function (product) {
          if (!slot.isConnected) return;
          const markup = livePriceMarkup(product);
          slot.setAttribute('aria-busy', 'false');
          if (!markup) {
            slot.hidden = true;
            return;
          }
          slot.innerHTML = markup;
          slot.classList.add('is-loaded');
        }).catch(function () {
          if (!slot.isConnected) return;
          slot.setAttribute('aria-busy', 'false');
          slot.hidden = true;
        });
      });
    }

    function cardHTML(product, position) {
      const priorityImage = position < 4;
      const image = product.image
        ? '<img src="' + escapeHTML(product.image) + '" alt="' + escapeHTML(product.imageAlt) + '" width="480" height="600" loading="' +
          (priorityImage ? 'eager' : 'lazy') + '"' + (priorityImage ? ' fetchpriority="high"' : '') + ' decoding="async">'
        : '<span class="fragrance-card__image-placeholder fragrance-card__image--placeholder" aria-hidden="true">Pellair Oils</span>';
      const selectedTerms = new Set(state.note.concat(state.accord).map(normalize));
      const terms = (product.accords.length ? product.accords : product.notes).filter(function (term) {
        return !selectedTerms.has(normalize(term));
      }).slice(0, 2);
      const termMarkup = terms.length
        ? '<div class="fragrance-card__terms" aria-label="Scent profile">' + terms.map(function (term) { return '<span>' + escapeHTML(term) + '</span>'; }).join('') + '</div>'
        : '';
      const reason = matchReason(product);
      const reasonMarkup = reason
        ? '<p class="fragrance-card__match">' + escapeHTML(reason) + '</p>'
        : '';
      return '<article class="fragrance-card is-visible">' +
        '<a class="fragrance-card__image" href="' + escapeHTML(product.href) + '">' + image + '</a>' +
        '<div class="fragrance-card__body">' +
           '<p class="eyebrow">' + escapeHTML(product.house || 'Fragrance oil') + '</p>' +
           '<h3><a href="' + escapeHTML(product.href) + '">' + escapeHTML(cardTitle(product)) + '</a></h3>' +
          reasonMarkup +
          termMarkup +
          '<div class="fragrance-card__commerce">' +
            '<div class="fragrance-card__price price" data-live-product-price data-product-handle="' + escapeHTML(product.handle) + '" aria-busy="true">' +
              '<span class="fragrance-card__price-skeleton" aria-hidden="true"></span>' +
            '</div>' +
            '<a class="button button--ghost button--small fragrance-card__shop" href="' + escapeHTML(product.href) + '">View oil</a>' +
          '</div>' +
        '</div>' +
      '</article>';
    }

    function renderActiveChips() {
      if (!activeChips) return;
      const chips = [];
      if (state.query) chips.push(['query', '', 'Search', state.query]);
      [
        ['brand', state.brand, 'Brand'],
        ['accord', state.accord, 'Accord'],
        ['note', state.note, 'Note'],
        ['group', state.group, 'Group']
      ].forEach(function (entry) {
        entry[1].forEach(function (value) { chips.push([entry[0], value, entry[2], value]); });
      });
      activeChips.innerHTML = chips.map(function (chip) {
        const accessibleLabel = 'Remove ' + chip[2].toLowerCase() + ' filter: ' + chip[3];
        return '<button type="button" class="fragrance-active-chip" data-remove-filter="' + chip[0] + '" data-remove-value="' +
          escapeHTML(chip[1]) + '" aria-label="' + escapeHTML(accessibleLabel) + '"><span>' + chip[2] + '</span>' +
          escapeHTML(chip[3]) + ' <b aria-hidden="true">×</b></button>';
      }).join('');
      activeChips.hidden = !chips.length;
      if (clear) {
        const hasState = chips.length > 0 || state.sort !== 'featured';
        clear.disabled = !hasState;
        clear.setAttribute('aria-disabled', String(!hasState));
      }
      if (moreFilterSummary) {
        const advancedCount = state.accord.length + state.group.length + (state.sort !== 'featured' ? 1 : 0);
        moreFilterSummary.textContent = advancedCount
          ? advancedCount + ' selected'
          : 'Accord and sort';
      }
    }

    function updateActiveStates() {
      root.querySelectorAll('[data-filter-note], [data-filter-group], [data-filter-mood], [data-filter-brand], [data-filter-accord]').forEach(function (button) {
        const noteValue = button.getAttribute('data-filter-note');
        const groupValue = button.getAttribute('data-filter-group') || button.getAttribute('data-filter-mood');
        const brandValue = button.getAttribute('data-filter-brand');
        const accordValue = button.getAttribute('data-filter-accord');
        const selected = noteValue ? active(state.note, noteValue)
          : groupValue ? active(state.group, groupValue)
          : brandValue ? active(state.brand, brandValue)
          : accordValue ? active(state.accord, accordValue)
          : false;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
    }

    function relevanceScore(product) {
      const query = normalize(state.query);
      const title = normalize(product.title);
      const house = normalize(product.house);
      let score = 0;
      if (query) {
        if (title === query) score += 500;
        else if (title.indexOf(query) === 0) score += 320;
        else if (title.indexOf(query) !== -1) score += 220;
        if (house === query) score += 180;
        else if (house.indexOf(query) === 0) score += 90;
        if (product.normalizedNotes.indexOf(query) !== -1) score += 170;
        if (product.normalizedAccords.indexOf(query) !== -1) score += 130;
        normalize(state.query).split(/\s+/).filter(Boolean).forEach(function (term) {
          if (title.split(/\s+/).indexOf(term) !== -1) score += 24;
          if (product.normalizedNotes.some(function (note) { return note.indexOf(term) !== -1; })) score += 16;
          if (product.normalizedAccords.some(function (accord) { return accord.indexOf(term) !== -1; })) score += 12;
        });
      }
      score += state.note.reduce(function (total, note) {
        return total + (product.normalizedNotes.indexOf(normalize(note)) !== -1 ? 24 : 0);
      }, 0);
      score += state.accord.reduce(function (total, accord) {
        return total + (product.normalizedAccords.indexOf(normalize(accord)) !== -1 ? 18 : 0);
      }, 0);
      score += state.group.reduce(function (total, group) {
        return total + (product.normalizedGroups.indexOf(normalize(group)) !== -1 ? 12 : 0);
      }, 0);
      return score;
    }

    function render() {
      if (!loaded) return;
      const hasIntent = Boolean(state.query || state.brand.length || state.accord.length || state.note.length || state.group.length);
      let filtered = products.filter(matches);
      if (state.sort === 'title-ascending' || state.sort === 'title-descending') {
        filtered = filtered.slice().sort(function (left, right) {
          const order = left.title.localeCompare(right.title);
          return state.sort === 'title-ascending' ? order : -order;
        });
      } else {
        filtered = filtered.slice().sort(function (left, right) {
          if (!hasIntent) return comparePopularity(left, right);
          return relevanceScore(right) - relevanceScore(left) ||
            comparePopularity(left, right);
        });
      }
      const visible = filtered.slice(0, state.visible);
      if (count) {
        count.textContent = filtered.length + (hasIntent ? ' matching oil' : ' oil') + (filtered.length === 1 ? '' : 's');
      }
      if (result) {
        result.hidden = false;
        result.innerHTML = visible.length
          ? visible.map(cardHTML).join('')
          : '<div class="empty-state empty-state--finder"><p>No exact match found. Remove one filter or reset.</p><button class="button button--small" type="button" data-fragrance-empty-reset>Reset filters</button></div>';
        if (visible.length) hydrateLivePrices(result);
        result.setAttribute('aria-busy', 'false');
        if (visible.length && !hasRenderedProductCards) {
          Array.from(result.children).slice(0, 8).forEach(function (card, index) {
            card.classList.add('fragrance-card--initial-reveal');
            card.style.setProperty('--finder-card-delay', Math.min(index, 7) * 45 + 'ms');
          });
          hasRenderedProductCards = true;
        }
      }
      if (loadMore) {
        const remaining = Math.max(0, filtered.length - visible.length);
        loadMore.hidden = remaining === 0;
        loadMore.textContent = remaining ? 'View more oils' : 'All oils shown';
      }
      renderActiveChips();
      updateActiveStates();
      announce(filtered.length
        ? 'Showing ' + visible.length + ' of ' + filtered.length + (hasIntent ? ' matching oil' : ' oil') + (filtered.length === 1 ? '' : 's') + '.'
        : 'No oils match the current filters.');
    }

    function commit(mode) {
      closePredictions();
      state.visible = defaultVisible;
      syncControls();
      render();
      writeURLState(state, mode || 'push');
    }

    function populate(data) {
      products = data.products;
      brands = countValues(products, function (product) { return product.house ? [product.house] : []; })
        .map(function (item) {
          const key = normalize(item.name);
          const popularIndex = POPULAR_HOUSE_RANK.has(key) ? POPULAR_HOUSE_RANK.get(key) : -1;
          const nicheIndex = NICHE_HOUSE_RANK.has(key) ? NICHE_HOUSE_RANK.get(key) : -1;
          return Object.assign({}, item, {
            category: popularIndex !== -1 ? 'Popular' : (nicheIndex !== -1 ? 'Niche' : ''),
            categoryRank: popularIndex !== -1 ? 0 : (nicheIndex !== -1 ? 1 : 2),
            curatedRank: popularIndex !== -1 ? popularIndex : (nicheIndex !== -1 ? nicheIndex : Number.MAX_SAFE_INTEGER)
          });
        })
        .sort(function (a, b) {
          return a.categoryRank - b.categoryRank ||
            a.curatedRank - b.curatedRank ||
            b.count - a.count ||
            a.name.localeCompare(b.name);
        });
      accords = countValues(products, function (product) { return product.accords; })
        .sort(function (a, b) { return b.count - a.count || a.name.localeCompare(b.name); });
      notes = countValues(products, function (product) { return product.notes; })
        .sort(function (a, b) { return b.count - a.count || a.name.localeCompare(b.name); });
      groups = countValues(products, function (product) { return product.groups; })
        .sort(function (a, b) { return GROUPS.findIndex(function (group) { return group.name === a.name; }) - GROUPS.findIndex(function (group) { return group.name === b.name; }); });

      optionItems(brand, brands, 'All brands');
      optionItems(accord, accords, 'All accords');
      optionItems(note, notes, 'All notes');
      optionItems(group, groups, 'All scent groups');
      enhanceSelect(brand, brands, {
        key: 'brand',
        label: 'Choose fragrance houses',
        placeholder: 'All brands',
        plural: 'brands',
        searchable: true,
        searchPlaceholder: 'Search brands'
      });
      enhanceSelect(accord, accords, {
        key: 'accord',
        label: 'Choose accords',
        placeholder: 'All accords',
        plural: 'accords',
        searchable: true,
        searchPlaceholder: 'Search accords'
      });
      enhanceSelect(note, notes, {
        key: 'note',
        label: 'Choose notes',
        placeholder: 'All notes',
        plural: 'notes',
        searchable: true,
        searchPlaceholder: 'Search notes'
      });
      enhanceSelect(group, groups, {
        key: 'group',
        label: 'Choose scent groups',
        placeholder: 'All scent groups',
        plural: 'scent groups',
        searchable: false
      });
      sanitizeSort();
      canonicalizeState();
      renderClouds();
      syncControls();

      if (stats) {
        stats.innerHTML = '<span><strong>' + products.length + '</strong> oils</span>' +
          '<span><strong>' + brands.length + '</strong> brands</span>' +
          '<span><strong>' + accords.length + '</strong> accords</span>' +
          '<span><strong>' + notes.length + '</strong> notes</span>';
      }
      loaded = true;
      root.classList.add('is-finder-ready');
      root.setAttribute('aria-busy', 'false');
      if (catalogFallback) {
        document.body.classList.remove('finder-catalog-loading');
        document.body.classList.add('finder-catalog-ready');
      }
      if (retry) retry.hidden = true;
      render();
      if (search) renderPredictions(search.value);
      writeURLState(state, 'replace');
    }

    async function load() {
      if (loaded || loading || !dataUrl) return;
      loading = true;
      if (catalogFallback) document.body.classList.add('finder-catalog-loading');
      root.setAttribute('aria-busy', 'true');
      renderLoadingState();
      if (count) count.textContent = 'Preparing the scent finder';
      announce('Preparing the scent finder.');
      if (retry) retry.hidden = true;
      if (fetchController) fetchController.abort();
      const controller = new AbortController();
      fetchController = controller;
      try {
        const data = await fetchLibrary(dataUrl, controller.signal);
        populate(data);
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        if (catalogFallback) document.body.classList.remove('finder-catalog-loading');
        root.setAttribute('aria-busy', 'false');
        renderErrorState();
        if (count) count.textContent = 'Scent finder unavailable';
        announce('The scent finder could not load. Check your connection and try again.', true);
        if (retry) retry.hidden = false;
      } finally {
        if (fetchController === controller) {
          fetchController = null;
          loading = false;
        }
      }
    }

    function toggleValue(key, value) {
      if (!value) return false;
      const wanted = normalize(value);
      const exists = state[key].some(function (entry) { return normalize(entry) === wanted; });
      state[key] = exists
        ? state[key].filter(function (entry) { return normalize(entry) !== wanted; })
        : state[key].concat(value);
      return true;
    }

    function toggle(key, value) {
      if (!toggleValue(key, value)) return;
      commit('push');
    }

    function reset() {
      state.query = '';
      state.brand = [];
      state.accord = [];
      state.note = [];
      state.group = [];
      state.sort = 'featured';
      state.visible = defaultVisible;
      searchHasHistoryEntry = false;
      closePredictions();
      commit('push');
    }

    function removeFilter(key, value) {
      if (key === 'query') {
        state.query = '';
        searchHasHistoryEntry = false;
      }
      else if (state[key]) {
        const wanted = normalize(value);
        state[key] = state[key].filter(function (entry) { return normalize(entry) !== wanted; });
      }
      commit('push');
    }

    function handleSelect(select, key) {
      if (!select) return;
      scope.listen(select, 'change', function () {
        ensureLoaded();
        const selected = selectedFrom(select);
        if (select.hasAttribute('data-fragrance-multi')) {
          state[key] = select.multiple ? selected : selected.reduce(function (values, value) {
            const wanted = normalize(value);
            return values.some(function (entry) { return normalize(entry) === wanted; })
              ? values.filter(function (entry) { return normalize(entry) !== wanted; })
              : values.concat(value);
          }, state[key]);
        } else {
          state[key] = selected;
        }
        commit('push');
        if (select.hasAttribute('data-fragrance-multi') && !select.multiple) select.value = '';
      });
    }

    function ensureLoaded() { load(); }

    if (search) {
      search.value = state.query;
      scope.listen(search, 'input', function () {
        ensureLoaded();
        renderPredictions(search.value);
        window.clearTimeout(inputTimer);
        inputTimer = window.setTimeout(function () {
          const nextQuery = search.value.trim();
          const historyMode = nextQuery && !searchHasHistoryEntry ? 'push' : 'replace';
          state.query = nextQuery;
          state.visible = defaultVisible;
          render();
          writeURLState(state, historyMode);
          searchHasHistoryEntry = Boolean(nextQuery);
        }, 180);
      });
      scope.listen(search, 'focus', function () {
        ensureLoaded();
        renderPredictions(search.value);
      });
      scope.listen(search, 'keydown', function (event) {
        if (event.key === 'Escape') {
          closePredictions();
          return;
        }
        if (event.key !== 'ArrowDown' || !predictions || predictions.hidden) return;
        const first = predictions.querySelector('[data-finder-prediction]');
        if (!first) return;
        event.preventDefault();
        setActivePrediction(first);
        first.focus();
      });
    }
    if (predictions) {
      scope.listen(predictions, 'keydown', function (event) {
        const items = Array.from(predictions.querySelectorAll('[data-finder-prediction]'));
        const currentIndex = items.indexOf(document.activeElement);
        if (event.key === 'Escape') {
          event.preventDefault();
          closePredictions();
          if (search) search.focus();
          return;
        }
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        const nextIndex = Math.max(0, Math.min(items.length - 1, currentIndex + direction));
        if (items[nextIndex]) {
          setActivePrediction(items[nextIndex]);
          items[nextIndex].focus();
        }
      });
      scope.listen(predictions, 'focusin', function (event) {
        const item = event.target.closest('[data-finder-prediction]');
        if (item) setActivePrediction(item);
      });
      scope.listen(predictions, 'click', closePredictions);
    }
    scope.listen(document, 'pointerdown', function (event) {
      if (searchControl && !searchControl.contains(event.target)) closePredictions();
    }, { passive: true });
    if (searchControl) {
      scope.listen(searchControl, 'focusout', function () {
        scope.timeout(function () {
          if (!searchControl.contains(document.activeElement)) closePredictions();
        }, 0);
      });
    }
    handleSelect(brand, 'brand');
    handleSelect(accord, 'accord');
    handleSelect(note, 'note');
    handleSelect(group, 'group');
    if (sort) {
      scope.listen(sort, 'change', function () {
        ensureLoaded();
        if (sort.value === 'shopify-best-selling') {
          const url = new URL(window.location.href);
          Object.keys(PARAMS).forEach(function (key) { url.searchParams.delete(PARAMS[key]); });
          url.searchParams.set('sort_by', 'best-selling');
          window.location.assign(url.pathname + url.search + url.hash);
          return;
        }
        state.sort = sort.value || 'featured';
        commit('push');
      });
    }
    if (clear) scope.listen(clear, 'click', reset);
    if (retry) scope.listen(retry, 'click', load);
    if (loadMore) scope.listen(loadMore, 'click', function () {
      state.visible += defaultVisible;
      render();
      writeURLState(state, 'replace');
    });

    scope.listen(root, 'click', function (event) {
      const emptyReset = event.target.closest('[data-fragrance-empty-reset]');
      if (emptyReset) { event.preventDefault(); reset(); return; }
      const remove = event.target.closest('[data-remove-filter]');
      if (remove) {
        event.preventDefault();
        removeFilter(remove.getAttribute('data-remove-filter'), remove.getAttribute('data-remove-value') || '');
        return;
      }
      const showNotes = event.target.closest('[data-show-more-notes]');
      if (showNotes) {
        event.preventDefault();
        state.noteVisible = Math.min(additionalNoteCount, state.noteVisible + NOTE_BATCH_SIZE);
        renderClouds();
        updateActiveStates();
        return;
      }
      const fewerNotesButton = event.target.closest('[data-show-fewer-notes]');
      if (fewerNotesButton) {
        event.preventDefault();
        state.noteVisible = initialNoteLimit;
        renderClouds();
        updateActiveStates();
        return;
      }
      const noteFilter = event.target.closest('[data-filter-note]');
      const groupFilter = event.target.closest('[data-filter-group], [data-filter-mood]');
      const brandFilter = event.target.closest('[data-filter-brand]');
      const accordFilter = event.target.closest('[data-filter-accord]');
      const filter = noteFilter || groupFilter || brandFilter || accordFilter;
      if (!filter) return;
      event.preventDefault();
      ensureLoaded();
      if (noteFilter) toggle('note', noteFilter.getAttribute('data-filter-note'));
      else if (groupFilter) toggle('group', groupFilter.getAttribute('data-filter-group') || groupFilter.getAttribute('data-filter-mood'));
      else if (brandFilter) toggle('brand', brandFilter.getAttribute('data-filter-brand'));
      else toggle('accord', accordFilter.getAttribute('data-filter-accord'));
    });

    scope.listen(root, 'focusin', ensureLoaded, { once: true });
    scope.listen(root, 'pointerdown', ensureLoaded, { once: true, passive: true });

    load();

    return {
      applyURL: function () {
        closePredictions();
        const next = readURLState();
        state.query = next.query;
        state.brand = next.brand;
        state.accord = next.accord;
        state.note = next.note;
        state.group = group ? next.group : [];
        state.sort = next.sort;
        const stateWasCanonicalized = loaded ? canonicalizeState() : false;
        searchHasHistoryEntry = Boolean(next.query);
        state.visible = restoredVisible(defaultVisible);
        syncControls();
        render();
        if (stateWasCanonicalized) writeURLState(state, 'replace');
      },
      pageHide: function () {
        closePredictions();
        closeEnhancedSelects();
        document.documentElement.classList.remove('finder-select-open');
        document.body.classList.remove('finder-select-open');
        if (fetchController) fetchController.abort();
      },
      pageShow: function () {
        if (!loaded && fetchController && fetchController.signal.aborted) {
          fetchController = null;
          loading = false;
        }
        if (!loaded) load();
        else this.applyURL();
      },
      editorSelect: load,
      destroy: function () {
        window.clearTimeout(inputTimer);
        if (fetchController) fetchController.abort();
        if (catalogFallback) document.body.classList.remove('finder-catalog-loading', 'finder-catalog-ready');
        scope.destroy();
      }
    };
  }

  function init(root) {
    queryRoots(root || document).forEach(function (element) {
      if (controllers.has(element)) return;
      try {
        controllers.set(element, createFinderController(element));
      } catch (error) {
        element.classList.add('is-finder-failed');
        const status = element.querySelector('[data-fragrance-status]');
        const retry = element.querySelector('[data-fragrance-retry]');
        if (status) {
          status.hidden = false;
          status.textContent = 'The scent finder could not start. Refresh the page and try again.';
        }
        if (retry) retry.hidden = false;
        if (window.console) console.error('[PellairFinder] Failed open.', error);
      }
    });
  }

  function destroy(root) {
    Array.from(controllers.entries()).forEach(function (entry) {
      const element = entry[0];
      const controller = entry[1];
      if (root === document || root === element || root && root.contains && root.contains(element)) {
        if (controller && controller.destroy) controller.destroy();
        controllers.delete(element);
      }
    });
  }

  function destroyAll() {
    destroy(document);
    globalScope.destroy();
  }

  globalScope.listen(document, 'shopify:section:load', function (event) { init(event.target); });
  globalScope.listen(document, 'shopify:section:unload', function (event) { destroy(event.target); });
  globalScope.listen(document, 'shopify:section:select', function (event) {
    Array.from(controllers.entries()).forEach(function (entry) {
      if ((event.target === entry[0] || event.target.contains(entry[0])) && entry[1].editorSelect) entry[1].editorSelect();
    });
  });
  globalScope.listen(window, 'popstate', function () {
    controllers.forEach(function (controller) { controller.applyURL(); });
  });
  globalScope.listen(window, 'pagehide', function (event) {
    controllers.forEach(function (controller) { if (controller.pageHide) controller.pageHide(event); });
  });
  globalScope.listen(window, 'pageshow', function (event) {
    if (!event.persisted) return;
    init(document);
    controllers.forEach(function (controller) { if (controller.pageShow) controller.pageShow(event); });
  });

  window.PellairFinderRuntime = {
    version: '29.1.0',
    init: init,
    destroy: destroy,
    destroyAll: destroyAll
  };

  if (document.readyState === 'loading') {
    globalScope.listen(document, 'DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
})();
